// Permission Center -- "ADDITIONAL PAGE ACCESS" section of the signed-in
// user's own account. Lists only the permissions the server returned as valid
// (/readMe), so nothing shows when a permission expired, was revoked, the
// account is suspended, the Permission Center is disabled, or a Switch Role is
// active. "Open Page" opens the real Elakay route; the page and its API are
// re-checked by the server on every request.
import React from "react";
import { Link } from "react-router-dom";
import { elakayAutoText as t } from "../pageInside/dataElakay";
import { getIndividualPermissions } from "./pageAccess";
import { getSelectedRoleOverride } from "../pageInside/Rolle";
import "./additionalPageAccess.css";

const ACTIONS = { get view() { return t("h_perm_action_view", "View"); }, get edit() { return t("h_perm_action_edit", "Edit"); } };

const AdditionalPageAccess = ({ infoSource }) => {
  const switched = Boolean(getSelectedRoleOverride() || infoSource?.selectedRole);
  const grants = getIndividualPermissions(infoSource).filter((g) => !g.expiresAt || new Date(g.expiresAt).getTime() > Date.now());
  if (!grants.length && !(switched && (infoSource?.individualPermissions || []).length)) return null;
  return (
    <section className="apa-section" aria-labelledby="apa-title">
      <h2 id="apa-title">{t("h_perm_apa_title", "ADDITIONAL PAGE ACCESS")}</h2>
      <p className="apa-muted">{t("h_perm_apa_desc", "Pages the Elakay owner opened for you individually. Your role does not change.")}</p>
      {switched ? (
        <p className="apa-notice" role="note">{t("h_perm_apa_switch", "Additional page access is not applied while a Switch Role is active. Return to your Default role to use it.")}</p>
      ) : (
        <div className="apa-table-scroll">
          <table className="apa-table">
            <thead><tr>
              <th scope="col">{t("h_perm_apa_page", "Page Name")}</th>
              <th scope="col">{t("h_perm_apa_url", "Page URL")}</th>
              <th scope="col">{t("h_perm_apa_permission", "Permission")}</th>
              <th scope="col">{t("h_perm_expiration", "Expiration")}</th>
              <th scope="col"><span className="apa-sr">{t("h_perm_apa_open", "Open Page")}</span></th>
            </tr></thead>
            <tbody>{grants.map((g) => (
              <tr key={g.pageKey}>
                <td data-label={t("h_perm_apa_page", "Page Name")}>{g.title}</td>
                <td data-label={t("h_perm_apa_url", "Page URL")}><code>{g.routePattern}</code></td>
                <td data-label={t("h_perm_apa_permission", "Permission")}>{(g.actions || []).map((a) => ACTIONS[a] || a).join(" + ")}</td>
                <td data-label={t("h_perm_expiration", "Expiration")}>{g.expiresAt ? new Date(g.expiresAt).toLocaleDateString() : t("h_perm_permanent", "Permanent")}</td>
                <td>{g.visitPath ? <Link className="apa-open" to={g.visitPath}>{t("h_perm_apa_open", "Open Page")}</Link> : "—"}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default AdditionalPageAccess;
